import React from "react";
import { MooringMateHomeHeader, GeneralFooter } from "../../../components";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import blogBanner from "../../../assets/berth.jpg";
import "./PrivacyPolicy.css";
import Typography from "@mui/material/Typography";

export const PrivacyPolicy = () => {
  return (
    <Box>
      <MooringMateHomeHeader />
      <Box className="page-title-section top-section" style={{ backgroundImage: `url(${blogBanner})` }}>
        <Box className="page-title-overlay"></Box>
        <Container maxWidth="lg">
          <Box style={{ textAlign: 'center' }}>
            <h1 className="page-heading">Privacy Policy</h1>
          </Box>
        </Container>
      </Box>
      <Box>
        <Container maxWidth="lg">
          <Grid
            className="blog-list"
            container
            style={{ padding: "50px 0px" }}
          >
            <Grid item xs={12}>
              <Typography variant="h6">
                Thank you for using DockingMate! Your trust means everything to
                us. That's why we're committed to keeping your personal data
                safe and letting you know how we use it. This Privacy Policy
                explains what information we collect, how we use it, and the
                choices you have.
              </Typography>
              <Typography variant="subtitle1">
                This policy applies to all users of the DockingMate website,
                platform, and related services.
              </Typography>
              <Typography mt={3} variant="h5">
                1. Information We Collect
              </Typography>
              <ul>
                <li>
                  {" "}
                  <Typography variant="subtitle1">
                    Personal Information
                  </Typography>{" "}
                  <ol>
                    <li>
                      <Typography variant="subtitle1">Full name</Typography>
                    </li>
                    <li>
                      <Typography variant="subtitle1">Email address</Typography>
                    </li>
                    <li>
                      <Typography variant="subtitle1">Phone number</Typography>
                    </li>
                    <li>
                      <Typography variant="subtitle1">Address</Typography>
                    </li>
                    <li>
                      <Typography variant="subtitle1">
                        Passport and ID documents (for verification and port
                        requirements)
                      </Typography>
                    </li>
                  </ol>
                </li>
                <li>
                  {" "}
                  <Typography variant="subtitle1">
                    Vessel Information
                  </Typography>{" "}
                  <ol>
                    <li>
                      <Typography variant="subtitle1">
                        Yacht name and registration details
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="subtitle1">
                        Insurance documents
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="subtitle1">
                        Captain's certificate or qualifications
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="subtitle1">
                        Arrival and departure schedules
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="subtitle1">
                        Berth location and characteristics
                      </Typography>
                    </li>
                  </ol>
                </li>
                <li>
                  {" "}
                  <Typography variant="subtitle1">Usage Data</Typography>{" "}
                  <ol>
                    <li>
                      <Typography variant="subtitle1">IP address</Typography>
                    </li>
                    <li>
                      <Typography variant="subtitle1">Device type</Typography>
                    </li>
                    <li>
                      <Typography variant="subtitle1">
                        Browser type and settings
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="subtitle1">
                        Pages visited, actions taken, and timestamps
                      </Typography>
                    </li>
                  </ol>
                </li>
                <li>
                  {" "}
                  <Typography variant="subtitle1">
                    Location Data
                  </Typography>{" "}
                  <ol>
                    <li>
                      <Typography variant="subtitle1">
                        {" "}
                        If enabled, approximate or precise location for better
                        berth matching
                      </Typography>
                    </li>
                  </ol>
                </li>
              </ul>

              <Typography mt={3} variant="h5">
                2. How We Use Your Information
              </Typography>
              <ul>
                <li>
                  {" "}
                  <Typography variant="subtitle1">
                    Facilitate berth rentals or swaps between users
                  </Typography>
                </li>
                <li>
                  {" "}
                  <Typography variant="subtitle1">
                    Send automated notifications to relevant ports
                  </Typography>{" "}
                </li>
                <li>
                  {" "}
                  <Typography variant="subtitle1">
                    Verify identities and vessel compliance
                  </Typography>
                </li>
                <li>
                  {" "}
                  <Typography variant="subtitle1">
                    Provide customer support
                  </Typography>{" "}
                </li>
                <li>
                  {" "}
                  <Typography variant="subtitle1">
                    Improve our services and platform functionality
                  </Typography>{" "}
                </li>
                <li>
                  {" "}
                  <Typography variant="subtitle1">
                    Comply with legal obligations
                  </Typography>{" "}
                </li>
              </ul>

              <Typography mt={3} variant="h5">
                3. Sharing Your Information
              </Typography>
              <Typography variant="subtitle1">
                We may share your data in the following circumstances:
              </Typography>
              <ul>
                <li>
                  {" "}
                  <Typography variant="subtitle1">
                    With Ports: Only relevant booking and verification documents
                    are sent to ports to process your arrival and departure.
                  </Typography>
                </li>
                <li>
                  {" "}
                  <Typography variant="subtitle1">
                    With Other Users: Limited information (vessel specs, user
                    rating, contact availability) is shared when arranging a
                    berth rental or swap.
                  </Typography>{" "}
                </li>
                <li>
                  {" "}
                  <Typography variant="subtitle1">
                    With Service Providers: We use third-party providers for
                    hosting, email, analytics, and identity verification. They
                    are contractually bound to protect your data.
                  </Typography>
                </li>
                <li>
                  {" "}
                  <Typography variant="subtitle1">
                    When Required by Law: We will disclose data if legally
                    compelled to do so.
                  </Typography>{" "}
                </li>
              </ul>

              <Typography mt={3} variant="h5">
                4. Data Security
              </Typography>
              <Typography variant="subtitle1">
                We implement technical and organizational measures to protect
                your data, including:
              </Typography>
              <ul>
                <li>
                  {" "}
                  <Typography variant="subtitle1">
                    End-to-end encryption
                  </Typography>
                </li>
                <li>
                  {" "}
                  <Typography variant="subtitle1">
                    Secure servers and firewalls
                  </Typography>{" "}
                </li>
                <li>
                  {" "}
                  <Typography variant="subtitle1">
                    Limited access controls
                  </Typography>
                </li>
                <li>
                  {" "}
                  <Typography variant="subtitle1">
                    Regular audits and vulnerability scans
                  </Typography>{" "}
                </li>
              </ul>

              <Typography mt={3} variant="h5">
                5. Data Retention
              </Typography>
              <Typography variant="subtitle1">
                We retain your information:
              </Typography>
              <ul>
                <li>
                  {" "}
                  <Typography variant="subtitle1">
                    As long as your account is active
                  </Typography>
                </li>
                <li>
                  {" "}
                  <Typography variant="subtitle1">
                    As necessary to fulfill services or legal obligations
                  </Typography>{" "}
                </li>
                <li>
                  {" "}
                  <Typography variant="subtitle1">
                    Until you request deletion (unless restricted by law)
                  </Typography>
                </li>
              </ul>

              <Typography mt={3} variant="h5">
                6. Your Rights
              </Typography>
              <Typography variant="subtitle1">
                You have the right to:
              </Typography>
              <ul>
                <li>
                  {" "}
                  <Typography variant="subtitle1">
                    Access the personal data we hold about you
                  </Typography>
                </li>
                <li>
                  {" "}
                  <Typography variant="subtitle1">
                    Request correction or deletion of your data
                  </Typography>{" "}
                </li>
                <li>
                  {" "}
                  <Typography variant="subtitle1">
                    Object to or restrict processing
                  </Typography>
                </li>
                <li>
                  {" "}
                  <Typography variant="subtitle1">
                    Withdraw consent where applicable
                  </Typography>
                </li>
                <li>
                  {" "}
                  <Typography variant="subtitle1">
                    Lodge a complaint with a supervisory authority
                  </Typography>
                </li>
              </ul>

              <Typography mt={3} variant="h5">
                7. Cookies and Tracking
              </Typography>
              <Typography variant="subtitle1">
                We use cookies and similar technologies to:
              </Typography>
              <ul>
                <li>
                  {" "}
                  <Typography variant="subtitle1">
                    Maintain your session
                  </Typography>
                </li>
                <li>
                  {" "}
                  <Typography variant="subtitle1">
                    Analyze traffic and usage
                  </Typography>{" "}
                </li>
                <li>
                  {" "}
                  <Typography variant="subtitle1">
                    Personalize content and recommendations You can manage
                    cookie preferences through your browser settings.
                  </Typography>
                </li>
              </ul>

              <Typography mt={3} variant="h5">
                8. International Users
              </Typography>
              <Typography variant="subtitle1">
                Your information may be processed and stored in countries
                outside your own. We ensure all international data transfers
                comply with applicable laws (e.g., GDPR, CCPA).
              </Typography>

              <Typography mt={3} variant="h5">
                9. Children’s Privacy
              </Typography>
              <Typography variant="subtitle1">
                Dockingmate is not intended for children under 16. We do not
                knowingly collect personal data from children. If we become
                aware of such data, we will delete it promptly.
              </Typography>

              <Typography mt={3} variant="h5">
                10. Updates to This Policy
              </Typography>
              <Typography variant="subtitle1">
                We may update this Privacy Policy from time to time. You will be
                notified of significant changes through the platform or via
                email.
              </Typography>
            </Grid>

            <Typography mt={5} variant="overline">
              Effective Date: 14/04/2025
            </Typography>
          </Grid>
        </Container>
      </Box>
      <GeneralFooter />
    </Box>
  );
};
